import { useState, useEffect } from "react";
import TFCookies from "../enums/tf-cookies";
import AdobeAnalyticsService from "../services/adobe-analytics-service";
import { initializeAdobeAnalytics } from "../utils/adobeAnalytics.utils";
import { parseRpDetailsValue } from "../utils/rpDetails.utils";

const getRpDetailsFromSession = () => {
  const cookieValue = sessionStorage.getItem(TFCookies.CODE.CIP_RPDETAILS);

  if (!cookieValue) {
    return null;
  }

  try {
    return parseRpDetailsValue(cookieValue);
  } catch (error) {
    console.error("Error parsing cookie value:", error);
    return null;
  }
};

const getThirdPartyScripts = (thirdPartyScripts) => {
  if (!thirdPartyScripts) {
    return [];
  }

  return thirdPartyScripts
    .toLowerCase()
    .split(",")
    .map((scriptName) => scriptName.trim());
};

const isThirdPartyScriptDisabled = (rpDetails, scriptName) => {
  if (rpDetails?.isThirdPartyScriptDisabled !== true) {
    return false;
  }

  return getThirdPartyScripts(rpDetails.thirdPartScripts).includes(scriptName);
};

const updateLogoLink = (logoLink) => {
  if (!logoLink) {
    return;
  }

  const logoLinkElement = document.getElementById("hfLifetechLogoLink");

  if (logoLinkElement) {
    logoLinkElement.href = logoLink;
  }
};

const updateFavicon = (logoLink) => {
  if (!logoLink?.includes("fisher")) {
    return;
  }

  const faviconLink = document.querySelector("link[rel='icon']");

  if (faviconLink) {
    faviconLink.href = `${logoLink}/favicon.ico`;
  }
};

const updateBranding = (rpDetails) => {
  updateLogoLink(rpDetails?.logoLink);
  updateFavicon(rpDetails?.logoLink);
};

const updateGlobalLinks = (rpDetails) => {
  window.tfIdentityGlobals?.setHeaderLogLink?.(rpDetails?.logoLink, true);
  window.tfIdentityGlobals?.setFooterLinks?.({
    privacy: rpDetails?.privacy_policy,
  });
  window.tfIdentityGlobals?.setHeaderCenterAlignment?.(
    rpDetails?.hideCommerceSidePanel === true,
  );
};

const initializeAdobe = (rpDetails) => {
  if (isThirdPartyScriptDisabled(rpDetails, "adobe")) {
    return;
  }
  AdobeAnalyticsService.setUpAdobeAnalytics();


  document.dispatchEvent(new CustomEvent("adobe"));
  initializeAdobeAnalytics();
};

const hideTrustArcLink = () => {
  const trustArcLink = document.getElementsByClassName("trustarc-link")[0];

  if (trustArcLink) {
    trustArcLink.style.display = "none";
  }
};

const initializeTrustArc = (rpDetails) => {
  if (!isThirdPartyScriptDisabled(rpDetails, "trustarc")) {
    return;
  }

  document.dispatchEvent(new CustomEvent("trustarc"));
  hideTrustArcLink();
};

const applyRpDetails = (rpDetails) => {
  if (!rpDetails) {
    return;
  }

  updateBranding(rpDetails);
  updateGlobalLinks(rpDetails);
  initializeAdobe(rpDetails);
  initializeTrustArc(rpDetails);
};

const useRedirectUrl = () => {
  const [redirectUrl, setRedirectUrl] = useState(() =>
    getRpDetailsFromSession(),
  );

  useEffect(() => {
    if (redirectUrl && typeof redirectUrl === "object") {
      applyRpDetails(redirectUrl);
      return undefined;
    }

    const intervalId = setInterval(() => {
      const rpDetailsObject = getRpDetailsFromSession();

      if (!rpDetailsObject) {
        return;
      }

      setRedirectUrl(rpDetailsObject);
      clearInterval(intervalId);
    }, 200);

    return () => clearInterval(intervalId);
  }, [redirectUrl]);

  return redirectUrl;
};

export default useRedirectUrl;
